import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import WindowedSelect  from "react-windowed-select";
import { Alert, Button, Card, CardFooter, Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import Columns3 from '../Columns3';
import { customComponents, customFilter } from './OptionsCustomSelect';



const AsignarAsociarDocuments = ({ShowAsignarInbound,setShowAsignarInbound,transformedOptions,SelectedAsociarDocumento,setSelectedAsociarDocumento,handleAgregarAsociarDocumento,getPageData3,handleRemoveDocumentoAsignado,ListAsociarDocumento,currentPage3,pageSize3,sizePerPageList,handleSizePerPageChange3,handlePageChange3,handleProcesarAsociarDocumento}) => {
  return (
    <Modal
        size="xl"
        fade={false}
        centered={true}
        isOpen={ShowAsignarInbound}
        toggle={() => setShowAsignarInbound(!ShowAsignarInbound)}
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={() => setShowAsignarInbound(!ShowAsignarInbound)}>
          Asignar
        </ModalHeader>
        <ModalBody>
          <Col lg={12}>
            <Card>
              <Row className="align-items-center">
                <Col lg={3}>
                  <Label className="ml-2">Asociar documento:</Label>

                  <WindowedSelect
                    options={transformedOptions}
                    isMulti={false} // Por ejemplo, permite selección múltiple
                    placeholder="Selecciona una opción"
                    filterOption={customFilter}
                    components={customComponents}
                    isClearable={true}
                    value={SelectedAsociarDocumento}
                    onChange={(x) => setSelectedAsociarDocumento(x)}
                  />
                </Col>

                <Col lg={2} className="d-flex align-items-end mt-auto">
                  <Button onClick={handleAgregarAsociarDocumento}>
                    Agregar
                  </Button>
                </Col>
              </Row>
              <Row className="mt-4">
                <div
                  className="table table-responsive"
                  style={{ overflowY: "auto", maxHeight: "300px" }}
                >
                  <BootstrapTable
                    key={"custom_table"}
                    remote={true}
                    pagination={
                      getPageData3().length > 0
                        ? paginationFactory({
                            page: currentPage3,
                            sizePerPage: pageSize3,
                            totalSize: ListAsociarDocumento.length,
                            sizePerPageList: sizePerPageList,
                            onSizePerPageChange: handleSizePerPageChange3,
                          })
                        : null
                    }
                    onTableChange={handlePageChange3}
                    columns={Columns3({ handleRemoveDocumentoAsignado })}
                    data={getPageData3()}
                    keyField={"itemId"}
                    responsive={true}
                    bordered={false}
                    striped={true}
                    classes={
                      "table align-middle table-nowrap table-sm customTable"
                    }
                    noDataIndication={
                      <span className="no-data-message">
                        No hay datos disponibles
                      </span>
                    }
                    headerWrapperClasses={"thead-light"}
                  />
                </div>

                {ListAsociarDocumento?.length == 0 && (
                  <Alert color="warning">
                    {" "}
                    Por favor, asegúrate de asociar al menos un documento antes
                    de guardar.{" "}
                  </Alert>
                )}
              </Row>

              <CardFooter className="d-flex justify-content-center">
                <Row>
                  <div className="text-sm-center block-inline">
                    <Button
                      className="btn"
                      color="link"
                      disabled={ListAsociarDocumento?.length == 0}
                      onClick={() => {
                        handleProcesarAsociarDocumento();
                      }}
                    >
                      Asignar
                    </Button>{" "}
                    <Button
                      className="btn"
                      color="danger"
                      onClick={() => {
                        setShowAsignarInbound(false);
                        // open(SelectedDocumentId);
                      }}
                    >
                      Cerrar
                    </Button>
                  </div>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </ModalBody>
      </Modal>

  )
}

export default AsignarAsociarDocuments